import { Client } from '@sr-sdks/api-sdk-axios';
import { Avatar, AvatarFallback } from '@sr/ui-library';
import { Table } from 'react-daisyui';
import AppLoader from '../../../components/Loader';
import { userInitials } from '../../../utils/helpers/common';

interface IFilteredClients {
  clientInfo?: string;
  clients: Client[];
  isLoading?: boolean;
}

const FilteredClients = ({
  clientInfo,
  clients,
  isLoading = false,
}: IFilteredClients) => {
  if (isLoading) {
    return <AppLoader.FlexLoader className="flex items-center" />;
  }

  return (
    <>
      {clientInfo && (
        <div className="mb-7 flex flex-col justify-center opacity-50">
          <p className="text-sm font-normal italic">{clientInfo}</p>
        </div>
      )}

      <Table className="border">
        <Table.Head hidden>
          {/* Remove the bracket if more than 1 Element */}
          <span>Client Profile</span>[]
        </Table.Head>

        <Table.Body>
          {clients.map(({ _id: clientId, clientName }) => (
            <Table.Row key={clientId} hover>
              {/* Remove the bracket if more than 1 Element */}
              {[
                <div
                  key={clientId}
                  className="flex items-center gap-4 text-base"
                >
                  <Avatar className="font-semibold text-sr-black">
                    <AvatarFallback>{userInitials(clientName)}</AvatarFallback>
                  </Avatar>
                  <span className="font-normal">{clientName}</span>
                </div>,
              ]}
            </Table.Row>
          ))}
        </Table.Body>
      </Table>
    </>
  );
};

export default FilteredClients;
